import { request } from "./request.js";

async function get(key) {
    return await request("/patient", { key: key }, "POST");
}

async function save(data) {
    return await request("/patient/save", data, "POST");
}

async function list(all = false) {
    const append = all === true ? '?all' : '';
    return await request("/patient/list" + append, {}, "POST");
}

export { save, get, list };
